import { styled } from '@grupoboticario/flora-react';

export default {
  Wrapper: styled('div', {
    width: '100%',
    display: 'flex',
    overflow: 'hidden',
  }),
  ContentLoaderWrapper: styled('div', {
    background: 'white',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '$4',
    margin: '$2 $4 0 0',
    borderRadius: '4px',
  }),
};
